/* eslint-disable jsx-a11y/alt-text */
import { ThreeDots } from 'react-loader-spinner'
import React, { useRef, useState } from "react";
import { BACKSPACE_KEY_CODE, NINE_NUMBER_KEY_CODE, ZERO_NUMBER_KEY_CODE } from "./keyCodes";
import colors from './colors';


export const Pill = ({ text }) => (<span className=" px-4 py-1 border-[2px] border-primary_800 bg-primary_200 text-black rounded-full">{text}</span>);

export const AuthStepsHeading = ({ text }) => (<h1 className=" text-center pb-2 pt-2 text-[1.8rem] md:text-[2.4rem] font-">{text}</h1>);
export const AuthStepsParagraph = ({ text }) => (<p className=' text-center text-xs'>{text}</p>);

export const ButtonWithoutIcon = ({ text, onButtonClick = () => { }, classNames = '', inversed = false }) => (
    <button
        className={` ${inversed ? ' bg-white text-black' : 'bg-black text-white'} rounded-full ${classNames}`}
        onClick={(e) => onButtonClick(e.target)}
    >
        {text}
    </button>
)
export const ButtonWithIcon = ({ text, onButtonClick = () => { }, onkeyDown = () => {}, classNames = '', icon, iconClassnames = '', inversed = false }) => (
    <button
        className={` flex gap-2 items-center justify-center ${inversed ? ' bg-white text-black' : 'bg-black text-white'} ${inversed && ' border-[0.04rem] border-inputbox-border-color'}  rounded-full ${classNames}`}
        onClick={(e) => {e.preventDefault(); onButtonClick(e.target)}}
        onKeyDown={(e)=> onkeyDown(e)}
    >
        {icon && <img
            src={icon}
            className='w-4  aspect-square'
        />}
        {text}
        {/* {icon && (<img src={icon} className={`${iconClassnames}`} />)} */}
    </button>
)

export const InputBoxWraper = ({ children, classnames, icon, iconAltText = '' }) => {
    return (
        <div
            className={`text-sm flex gap-2 p-2 rounded-lg ${classnames} border-[0.08rem] border-inputbox-border-color`}>
            {icon ? (<div className=' w-8 aspect-square flex items-center justify-center rounded-full bg-svg-icons-background'>
                <img
                    src={icon}
                    className='w-4 aspect-square'
                    alt={iconAltText}
                />
            </div>
            ) : (<span className=' h-8'></span>)}
            {children}
        </div>)
};

export const TopBottomBorder = ({ children, classnames = '' }) => (<div className={` border-[#f0f0f0] border-t-[1px] border-b-[1px] ${classnames}`}>{children}</div>)

export const OTP_Filler = ({ state = [], length = 0, click = () => { }, setState = () => { } }) => {
    const [currentLastIndex, setCurrentLastIndex] = useState(-1);
    const ref = useRef();

    const keyDown = (index, event) => {
        let lastIndex = currentLastIndex; // last active index
        const keyCode = event.keyCode;


        if (keyCode >= ZERO_NUMBER_KEY_CODE && keyCode <= NINE_NUMBER_KEY_CODE && lastIndex < length - 1) {


            const current = lastIndex + 1;
            // Now cuurent is index which need to fill

            // updating new value at current index
            setState((pre) => {
                const arr = [...pre];
                arr[current] = event.key;
                return arr;
            });

            // removing focus from current filed input
            ref.current.children?.[current]?.blur();

            // activating next input 
            ref.current?.children?.[current + 1]?.select();

            // setting current index for next iteration 
            setCurrentLastIndex(current);
        }

        if (keyCode === BACKSPACE_KEY_CODE && currentLastIndex > -1) {
            let currentIndex = lastIndex;
            // this in now updateable index 


            // removing item from current activated index
            const list = [...state];
            list[currentIndex] = '';
            setState(list);

            // removing focus from current index
            ref.current.children?.[currentIndex]?.blur();
            currentIndex -= 1;

            // adding focus to new activated index
            ref.current?.children?.[currentIndex]?.select();
            setCurrentLastIndex(currentIndex)
        }
    }
    return (<div className=" flex gap-2 my-2" ref={ref}>
        {state?.map((item, index) => (
            <input
                key={index}
                type="text"
                maxLength={1}
                value={item}
                className="px-3 py-0 border-[1px] outline-none rounded-md  w-12 h-12 bg-gray-200"
                onKeyDown={(e) => keyDown(index, e)}
                onChange={() => { }}
            />))}
    </div>)
}

export const Job_Tag_Box = ({ text }) => (<span className=' p-3 py-1.5 bg-gray-100 rounded-lg text-xs text-black'>{text}</span>);
export const Job_Tag_Box_Primary = React.memo(({ text }) => (<span className=' p-3 py-1.5 bg-gray-100 rounded-lg text-xs text-primary-color-900'>{text}</span>));


export const Loader = () => {

    // return (<div className=' w-full flex justify-center'>
    //     <p className=' font-semibold'>{loadingtext}</p>
    // </div>)


    return (<div className=' w-full flex justify-center'>
        <ThreeDots
            height="80"
            width="80"
            radius="9"
            color={colors.primary_900}
            ariaLabel="three-dots-loading"
            wrapperStyle={{}}
            wrapperClassName=""
            visible={true}
        />
    </div >
    )
}


export const NextQuestionComponent = () => (
    <div className=' flex items-center justify-center w-full h-32'>
        <h1 className=' text-2xl font-semibold'>Your Answer is submiting....</h1>
    </div>
)

export const InterviewCompleted = () => (
    <div className=' flex items-center justify-center w-full h-32'>
        <h1 className=' text-2xl font-semibold'>Your Interview is completed...</h1>
    </div>
)
export const QuestionLoading = () => (
    <div className=' flex items-center justify-center w-full h-32'>
        <h1 className=' text-2xl font-semibold'>Question Loading...</h1>
    </div>
)
export const InterviewQuestionError = () => (
    <div className=' flex items-center justify-center w-full h-32'>
        <h1 className=' text-2xl font-semibold'>Error while getting question. Make sure your url is correct</h1>
    </div>
)

export const MainLogoComponent = () => (<h1 className=' text-5xl font-bold'>Talent <span className=' text-blue-700'>Ai</span></h1>);

export const WhiteBoxWrapper = ({ children, classes }) => (<div className={`bg-white-bg-color rounded-lg p-4 ${classes}`}>{children}</div>)

export const OrBetweenButtons = () => (<div className=' flex items-center'>
    <span className=' flex-1 h-[0.08rem] bg-gradient-to-r from-[#7D7D7D00] to-[#7D7D7D]' ></span>
    <span className=' mx-4'>OR</span>
    <span className='flex-1  h-[0.08rem] bg-gradient-to-r from-[#7D7D7D] to-[#7D7D7D00]'></span>
</div>)